import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
    }

    renderToggleButton() {
        return (
            <button className="menu-toggle" onClick={this.toggleNavbar}>
                {this.state.collapsed ? 'Hide Menu' : 'Show Menu'}
            </button>
        );
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
        const menu = document.querySelector('.navbar-collapse');
        menu.classList.toggle('hidden-menu');
    }

  render () {
      return (

        <header>
              {this.renderToggleButton()}
              
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 navbar-collapse" light>
          <Container>
            <NavbarBrand tag={Link} to="/">WordGrid</NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                      
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/">Home</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/new-game-offline">New offline game (pad)</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/new-game-online/new">Host online game</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="/join-by-code">Join online game</NavLink>
                </NavItem>
              </ul>
          </Container>
                  </Navbar>
              </header>
    );
  }
}
